<ez-main-layout [showWithdrawalLink]="true">
  <p>
    Wir haben Ihre Daten bereits erhalten, oder Ihr Zugangscode ist abgelaufen. Ein erneutes Absenden der Daten ist
    nicht möglich.
  </p>
  <p>Vielen Dank für Ihre Unterstützung.</p>
</ez-main-layout>
